import React, { useEffect, useMemo, useState } from 'react';
import { Button, Tabs, Tab, Box } from '@mui/material';
import NotificationRow from '../components/Notifications/NotificationRow';
import { NotificationsApi } from '../api/notificationsApi';
import { getSerialNumber } from '../utils/sharedFunctions';
import useListingActions from '../hooks/useListingActions';
import { actionBtn } from '../styles';
import useTranslation from '../hooks/useTranslation';
import { ListingPage, ListTable  } from '../shared-components'

const NotificationsContainer = () => {
  const { t } = useTranslation();
  const [tab, setTab] = useState('unread');

  const {
    data,
    count,
    page,
    perPage,
    setData,
    handlerForSearchingAndSortingChange,
    fetchData,
  } = useListingActions(
    'notifications',
    (params, dep) => NotificationsApi.getNotifications(params, dep),
    'Latest', () => ({ status: tab })
  );

  useEffect(() => {
    fetchData({ page: 1, per_page: perPage });
  }, []);

  useEffect(() => {
    fetchData({ page: 1, per_page: perPage });
  }, [tab]);

  const markRead = async (id) => {
    await NotificationsApi.markAsRead(id);
    setData((rows) =>
      tab === 'unread'
        ? rows.filter((r) => r.id !== id)
        : rows.map((r) => (r.id === id ? { ...r, status: 'read' } : r))
    );
  };

  const deleteNotification = async (id) => {
    if (!window.confirm(t('labels.are_you_sure'))) return;
    await NotificationsApi.removeNotification(id);
    setData((rows) => rows.filter((r) => r.id !== id));
  };

  const { body, heading } = useMemo(() => {
    const bodyRows = (data || []).map((n, idx) => (
      <NotificationRow
        key={n.id}
        {...n}
        index={getSerialNumber(page, perPage, idx)}
        onRead={markRead}
        onDelete={deleteNotification}
        data={n.data}
      />
    ));
    return {
      body: bodyRows,
      heading: [ 'Id', 'Title', 'Message', 'Type', 'Status', 'Actions', ]
    };
  }, [data, page, perPage, t]);

  const actions = (
    <>
      {tab === 'unread' && (
        <Button
          color="primary"
          variant="outlined"
          sx={actionBtn}
          onClick={async () => {
            await NotificationsApi.markAllAsRead();
            setData([]);
          }}
        >
          {t('labels.mark_all_read')}
        </Button>
      )}
    </>
  );

  return (
    <ListingPage
      title={t('labels.notifications')}
      actions={actions}
      table={
        <Box>
          <Box sx={{ mb: 2 }}>
            <Tabs
              value={tab}
              onChange={(_, value) => setTab(value)}
              aria-label="notifications tabs"
              sx={{ minHeight: 40 }}
            >
              <Tab label={t('labels.unread')} value="unread" />
              <Tab label={t('labels.read')} value="read" />
            </Tabs>
          </Box>
          <ListTable
            tableHeadings={heading}
            tableContent={body}
            count={count}
            page_no={page}
            rowsPerPage={perPage}
            onPageChange={(_, pageNo) => handlerForSearchingAndSortingChange('page', pageNo + 1)}
            handleChangeRowsPerPage={(e) => handlerForSearchingAndSortingChange('pageSize', e.target.value)}
            rowsControl
          />
        </Box>
      }
    />
  );
};

export default NotificationsContainer;